import { render, staticRenderFns } from "./ShortListCandidates.vue?vue&type=template&id=ed1b075e"
import script from "./ShortListCandidates.vue?vue&type=script&lang=js"
export * from "./ShortListCandidates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports